import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    coupon: {},
    coupons: [],
    error: null,
    loading: false,
    sloading: false,
}

export const createCouponReq = createAsyncThunk('createCouponReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/create/coupon`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    navigate('/admin/coupons');
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const listCouponReq = createAsyncThunk('listCouponReq', async ({ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/list/coupon`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteCouponReq = createAsyncThunk('deleteCouponReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/delete/coupon/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res.data.success) {
                    dispatch(toastSuccess(res.data.message))
                    dispatch(listCouponReq({}))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const couponInfoReq = createAsyncThunk('couponInfoReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/coupon/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const couponUpdateReq = createAsyncThunk('couponUpdateReq', async ({ id, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/coupon/update/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res.data.success) {
                    dispatch(toastSuccess(res.data.message))
                    navigate('/admin/coupons');
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const CouponSlice = createSlice({
    name: 'CouponSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(createCouponReq.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(createCouponReq.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(createCouponReq.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })
        builder.addCase(listCouponReq.pending, (state, action) => {
            state.loading = true
            state.coupons = []
            return state
        })
        builder.addCase(listCouponReq.fulfilled, (state, action) => {
            state.loading = false
            state.coupons = action.payload.data
            return state
        })
        builder.addCase(listCouponReq.rejected, (state, action) => {
            state.loading = false
            state.coupons = []
            state.error = 'Error occured'
        })
        builder.addCase(couponInfoReq.pending, (state, action) => {
            state.loading = true
            state.coupon = {}
            return state
        })
        builder.addCase(couponInfoReq.fulfilled, (state, action) => {
            state.loading = false
            state.coupon = action.payload.data
            return state
        })
        builder.addCase(couponInfoReq.rejected, (state, action) => {
            state.loading = false
            state.coupon = {}
            state.error = 'Error occured'
        })

        builder.addCase(couponUpdateReq.pending, (state, action) => {
            state.sloading = true
            state.coupon = {}
            return state
        })
        builder.addCase(couponUpdateReq.fulfilled, (state, action) => {
            state.sloading = false
            state.coupon = action.payload.data
            return state
        })
        builder.addCase(couponUpdateReq.rejected, (state, action) => {
            state.sloading = false
            state.coupon = {}
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default CouponSlice.reducer